<template>
  <div
    class="h6 text-center rounded text-white px-0 bg-condiciones w-100 pb-2 pt-2"
  >
    <h5 class="gilmer"><strong>¡ATENCIÓN!</strong></h5>
    <div class="col p-2 text-justify">
      <span class="inicial h5"
        >Si tu estudiante es asignado a un nuevo establecimiento,
        <strong
          >perderá automáticamente su cupo en el colegio actual para el próximo
          año, independientemente de si aceptas o rechazas la asignación durante
          la etapa de resultados.
        </strong>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "InformacionAceptaCondiciones",
  data() {
    return {
      ayuda: PLATAFORMA.AYUDA,
      etapaProceso: ""
    };
  },
  created() {
    const obtenerValorLocalStorage = (key, valorPorDefecto = "----") => {
      const valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.etapaProceso = obtenerValorLocalStorage("etapaProceso");
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/login/InformacionAceptaCondiciones.vue